import moment from "moment";
import {_CONST} from "@/constants/constants";

export interface DateRange {
  from: string | null;
  to: string | null;
}

export function getPrecision(val = 0): any {
  let s = (+val).toString();

  const eChunks = s.split('e');
  if (+eChunks[1] < 0) return -eChunks[1];

  s = s.replace(',', '.');
  let chunks = s.split('.');
  if (!chunks[1]) return 0;
  return chunks[1].length;
}

const DEFAULT_TIMEZONE = 'Europe/Moscow';

export function convertDateRange(dateRange: DateRange | null, isShort: boolean, useTime = false, tz = _CONST.timeZoneType.local, converTime = false): DateRange | null {
  if (!dateRange) return null;

  const momentDate = (date: string | null) => {
    switch (tz) {
      case _CONST.timeZoneType.server:
        const mDate = moment(date).utcOffset(date as string);
        mDate.tz(DEFAULT_TIMEZONE, converTime);
        return mDate

      case _CONST.timeZoneType.local:
      default:
        return moment(date);
    }
  }

  const dateFormat = isShort
    ? 'YYYY-MM-DD'
    : (useTime ? 'YYYY-MM-DD[T]HH:mm:ssZ' : 'YYYY-MM-DD[T]00:00:00Z')

  if (typeof dateRange === 'object')
    return {
      from: momentDate(dateRange.from).format(dateFormat),
      to: momentDate(dateRange.to).format(dateFormat)
    }

  return {
    from: momentDate(dateRange).format(dateFormat),
    to: momentDate(dateRange).format(dateFormat)
  }
}

export function parseDoubleDate(doubleDate: string): DateRange | null {
  if (!doubleDate) return null;

  let tmp = doubleDate.split('|');
  let result = null;

  if (tmp.length === 2) {
    let from = moment(tmp[0]);
    let to = moment(tmp[1]);
    if (from.isValid() && to.isValid()) {
      result = { from: from.toISOString(true), to: to.toISOString(true) };
    }
  }

  return result;
}

export function getRandomEnum<T>(anEnum: T): T[keyof T] {
  const enumValues = Object.keys(anEnum)
    .map(n => Number.parseInt(n))
    .filter(n => !Number.isNaN(n)) as unknown as T[keyof T][]
  const randomIndex = Math.floor(Math.random() * enumValues.length)
  return enumValues[randomIndex];
}

export function autoSpaces(value: any) {
  if (!value) return ''
  return value.toString().replace(/([a-z])([A-Z])/g, '$1 $2')
}

export function getObjectKey(val: any, o = {}) {
  const keys = Object.keys(o)
  const values = Object.values(o)

  const index = values.indexOf(val)

  return index >= 0 ? keys[index] : null
}

export function getOptionsFromEnum(anEnum: any, isNeedBlank: boolean = true, moreItems?: Array<any> | null, labelFilter?: any, useValues: boolean = false): Array<any> {
  let result: Array<any> = [];

  if (isNeedBlank) {
    result.push({
      label: '--Все--',
      value: undefined
    });
  }

  const enumKeys = Object.keys(anEnum);

  let enumArray = enumKeys.map((key: string): any => {
    let label = anEnum[key];

    if (labelFilter) label = labelFilter(label);

    return {
      label,
      value: useValues ? anEnum[key] : key,
    }
  });

  result = [
    ...result,
    ...enumArray
  ];

  if (moreItems) {
    result = [
      ...result,
      ...moreItems
    ];
  }

  return result;
}


export function enum2Array<T>(anEnum: T) {
  return Object.values(anEnum).filter(x => typeof x === 'string')
}

export function enum2Object<T>(anEnum: T) {
  let arr =  enum2Array(anEnum);
  let obj: any = {};

  for (let i = 0; i < arr.length; i++) {
    const key: any = arr[i];
    obj[arr[i]] = (anEnum as any)[key];
  }

  return obj;
}

export function enumKeys2Object<T>(anEnum: T) {
  let arr =  enum2Array(anEnum);
  let obj: any = {};

  for (let i = 0; i < arr.length; i++) {
    obj[arr[i]] = arr[i];
  }

  return obj;
}

export function isExist(value: any) {
  return ![null, undefined].includes(value)
}

export const forceFileDownload = (response: any, title: any) => {
  const url: any = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', title)
  document.body.appendChild(link)
  link.click()
}
